/* Load-more for the collection grid. Progressive enhancement: the inner <a>
   links to the next page and works with JS off; this element intercepts the
   click, fetches the next page, and appends its products to the current list. */
(function () {
  if (customElements.get('load-more-button')) return;

  customElements.define('load-more-button', class extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.link = this.querySelector('a');
      if (this.link) this.link.addEventListener('click', (e) => this.load(e));
    }

    async load(e) {
      e.preventDefault();
      const url = this.dataset.url;
      if (!url || this.loading) return;
      this.loading = true;
      this.classList.add('is-loading');
      if (this.link) this.link.setAttribute('aria-busy', 'true');

      try {
        const res = await fetch(url);
        if (!res.ok) throw new Error(res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');

        const listId = this.dataset.list;
        const newList = doc.getElementById(listId);
        const curList = document.getElementById(listId);
        if (newList && curList) {
          // A ring family split across pages already has its card here.
          const added = Array.from(newList.children).filter((node) =>
            !(node.dataset && node.dataset.family && curList.querySelector(`[data-family="${CSS.escape(node.dataset.family)}"]`)));
          added.forEach((node) => curList.appendChild(node));

          // The theme reveals cards from opacity:0 via an IntersectionObserver on
          // initial render. JS-injected nodes are never observed, so they'd stay
          // invisible (taking space but blank). Force them to the revealed state.
          added.forEach((node) => {
            if (node.nodeType !== 1) return;
            const targets = [];
            if (node.matches('[reveal-on-scroll]')) targets.push(node);
            targets.push.apply(targets, node.querySelectorAll('[reveal-on-scroll]'));
            targets.forEach((el) => {
              el.removeAttribute('reveal-on-scroll');
              el.style.opacity = '1';
              el.style.transform = 'none';
            });
          });
        }

        // Advance to the next page from the freshly fetched markup, or finish.
        const next = doc.querySelector('load-more-button');
        if (next && next.dataset.url) {
          this.dataset.url = next.dataset.url;
          if (this.link) this.link.href = next.dataset.url;
        } else {
          this.remove();
        }
      } catch (err) {
        window.location.href = url; // graceful fallback to a normal page load
      } finally {
        this.loading = false;
        this.classList.remove('is-loading');
        if (this.link) this.link.removeAttribute('aria-busy');
      }
    }
  });
})();
